import { Box, Button, Flex, HStack, SimpleGrid, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import CustomDateRangePicker from "../Customer-dashboard/CustomDateRangePicker";

const Stats = ({ fromDate, toDate, setFromDate, setToDate,fetchStats,stats }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  
  const [activeRange, setActiveRange] = useState("Today");

  // fetch stats using current fromDate, toDate


  // fetch stats whenever date changes
  useEffect(() => {
    if (fromDate && toDate) fetchStats();
    // eslint-disable-next-line
  }, [fromDate, toDate]);

  const handleDateRangeClick = (range) => {
    setActiveRange(range);
    setShowDatePicker(range === "Custom");

    const today = dayjs();
    if (range === "Today") {
      setFromDate(today.format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    } else if (range === "Last7") {
      setFromDate(today.subtract(6, "day").format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    } else if (range === "Last30") {
      setFromDate(today.subtract(29, "day").format("YYYY-MM-DD"));
      setToDate(today.format("YYYY-MM-DD"));
    }
  };

  const handleApplyDateRange = ({ fromDate, toDate }) => {
    setFromDate(fromDate);
    setToDate(toDate);
  };


  return (
    <>
      <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={3}>
        <Box>
          <Text fontSize="2xl" fontWeight="bold">
            Order History
          </Text>
          <Text fontSize="sm" color="gray.600">
            {fromDate} → {toDate}
          </Text>
        </Box>

        <HStack spacing={2} flexWrap="wrap">
          {["Today", "Last7", "Last30", "Custom"].map((label) => (
            <Button
              key={label}
              size="sm"
              variant={activeRange === label ? "solid" : "outline"}
              colorScheme={label === "Custom" ? "orange" : "gray"}
              onClick={() => handleDateRangeClick(label)}
            >
              {label === "Last7"
                ? "Last 7 Days"
                : label === "Last30"
                ? "Last 30 Days"
                : label === "Custom"
                ? "Custom Date"
                : "Today"}
            </Button>
          ))}
        </HStack>
      </Flex>

      <SimpleGrid columns={[2, 2, 4]} spacing={4} mb={6}>
        {   [
      {
        label: "Assigned",
        value: stats.totalAssigned,
      },
      {
        label: "Completed",
        value: stats.totalCompleted,
      },
      {
        label: "Pending",
        value: stats.totalInProgress,
      },
      {
        label: "Cancelled",
        value: stats.totalCancelled,

      },
    ].map((card, idx) => (
          <Box key={idx} bg="white" borderRadius="md" p={4} shadow="sm">
            <Text fontWeight="bold">{card.label}</Text>
            <Text fontSize="2xl">{card.value}</Text>
          </Box>
        ))}
      </SimpleGrid>

      {showDatePicker && (
        <Box mb={4}>
          <CustomDateRangePicker
            onApply={handleApplyDateRange}
          />
        </Box>
      )}
    </>
  );
};

export default Stats;
